import React, { Component } from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";

import {
  HomeIcon,
  StoreIcon,
  LocalOfferIcon,
  CompareIcon,
  BlockIcon,
  PenIcon,
  ListIcon,
  CloseIcon
} from "../SVGIcons";

import "./LeftMenu.css";

class LeftMenu extends Component {
  state = {
    visible: false
  };

  componentDidMount() {
    setTimeout(() => {
      this.setState({ visible: true });
    }, 0);
  }

  hide = () => {
    this.setState({ visible: false });
    setTimeout(this.props.onClose, 250);
  };

  onClick = e => {
    if (e.target === this.div) {
      this.hide();
    }
  };

  onLogout = () => {
    this.props.onChange(true)
    this.onRoute()
  }

  onRoute = () => {
    setTimeout(this.hide, 100);
  };

  render() {
    const { visible } = this.state;
    return (
      <div
        className={classNames("LeftMenu", { visible })}
        ref={div => (this.div = div)}
        onClick={this.onClick}
      >
        <div>
          <nav>
            <Link onClick={this.onRoute} to="/">
              <HomeIcon />
              Home
            </Link>
            <Link onClick={this.onRoute} to="/lbus">
              <StoreIcon />
              LBUs
            </Link>
            <Link onClick={this.onRoute} to="/categories">
              <LocalOfferIcon />
              Categories
            </Link>
            <Link onClick={this.onRoute} to="/synonyms">
              <CompareIcon />
              Synonyms
            </Link>
            <Link onClick={this.onRoute} to="/blockwords">
              <BlockIcon />
              Block words
            </Link>
            <Link onClick={this.onRoute} to="/cms">
              <PenIcon />
              CMS
            </Link>
            <Link onClick={this.onRoute} to="/zero-hits">
              <ListIcon />
              Zero hits
            </Link>
            <Link onClick={this.onLogout} to="/">
              <CloseIcon />
              Logout
            </Link>
          </nav>
        </div>
      </div>
    );
  }
}

export default LeftMenu;



// WEBPACK FOOTER //
// ./src/components/LeftMenu/LeftMenu.js